/*!

=========================================================
* Black Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classnames from "classnames";
// react plugin used to create charts
import { Line, Bar } from "react-chartjs-2";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";

import logo from "assets/img/TheDeepSharksLogo.jpg";
import topPicture from "assets/img/OutsideSandCourt2.jpg";

// reactstrap components
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Label,
  FormGroup,
  Input,
  Progress,
  Table,
  Row,
  Col,
  Grid,
  UncontrolledTooltip, CardImg, Form, InputGroup, InputGroupAddon, InputGroupText, Container,CardImgOverlay,
} from "reactstrap";

const Home = () => {
  const [state, setState] = React.useState({});
  return (
    <>
      <div className="content">
        <Container>
          <Col className="ml-auto mr-auto" lg="10" md="12">
            <Form className="form">
              <Card className="bg-dark text-white">
                <CardImg top src={topPicture} alt="Outside Sand Court"></CardImg>

                <CardFooter>
                  <Button
                      block
                      className="mb-3"
                      color="info"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                      size="lg"
                  >
                    Welcome to The Deep Dashboard!
                  </Button>
                </CardFooter>
              </Card>
            </Form>
          </Col>
        </Container>
      </div>
    </>
  );
};

export default Home;
